module.exports = __webpack_public_path__ + "img/image1.d5c2e8fd.jpg";